import script from "./button-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./button-loading.vue?vue&type=script&setup=true&lang=js"

import "./button-loading.vue?vue&type=style&index=0&id=37756b13&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37756b13"]])

export default __exports__